const document = (state = "", action) => {
    switch (action.type){
        case 'SET_FILE_NAME':
            console.log(action)
            return action.fileName
        default:
            return state
    }
}

export default document
